import { DoctorProfileStatus, Gender } from 'types/api/users';
import { PlanType } from 'types/api/doctorPlans';

export const USER_ROLES = {
  doctor: 'doctor',
  patient: 'patient',
  translator: 'translator',
  admin: 'admin'
} as const;

// Phase E Cycle 2 canonical (BE DoctorProfileStatus). Was numeric.
export const PROFILE_STATUS = {
  waiting: DoctorProfileStatus.Waiting,
  active: DoctorProfileStatus.Active,
  disabled: DoctorProfileStatus.Disabled,
  inactive: DoctorProfileStatus.Inactive
} as const satisfies Record<string, DoctorProfileStatus>;

// PLANS — Phase E Cycle 4 canonical (BE PlanType).
export const PLAN_TYPE_VALUES = {
  video_call: PlanType.VideoCall,
  report: PlanType.Report
} as const satisfies Record<string, PlanType>;

export const PLAN_TYPE_LABELS = {
  [PlanType.VideoCall]: 'video_call',
  [PlanType.Report]: 'report'
} as const satisfies Record<PlanType, string>;

export const PLAN_TYPES: Array<{ value: PlanType; label: string }> = [
  { value: PlanType.VideoCall, label: 'video_call' },
  { value: PlanType.Report, label: 'report' }
];

export const PLAN_DURATIONS = [
  {
    label: '15m',
    value: 0.25
  },
  {
    label: '30m',
    value: 0.5
  },
  {
    label: '1h',
    value: 1
  },
  {
    label: '2h',
    value: 2
  },
  {
    label: '3h',
    value: 3
  }
];

// Phase E Cycle 5 canonical Gender. Was numeric '1' / '2'.
export const GENDERS: Array<{ value: Gender; label: string }> = [
  { value: Gender.Male, label: 'Male' },
  { value: Gender.Female, label: 'Female' }
];

export const GENDERS_VALUES = {
  [Gender.Male]: 'male',
  [Gender.Female]: 'female'
} as const satisfies Record<Gender, string>;

export type GenderKeyType = Gender;

export const USER_VERIFY = {
  phone: 2,
  email: 4,
  verified: 6
} as const;

export const VERIFY_USERS = [
  {
    value: USER_VERIFY.email,
    label: 'Email'
  },
  {
    value: USER_VERIFY.phone,
    label: 'Phone'
  },
  {
    value: USER_VERIFY.verified,
    label: 'Full Verified'
  }
];
export const LANGUAGES_USER = [
  {
    value: 'en',
    label: 'English'
  },
  {
    value: 'ru',
    label: 'Russian'
  },
  {
    value: 'de',
    label: 'German'
  }
];
